/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { Component } from 'react';
import DatePicker from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import { Input, Select } from '../../ui/NewForm';

import * as Styles from './index.styles';
import { Icon } from '../../ui/Icon';

import scrollBlocker from '../../../utils/scrollBlocker.js';
import { isMobileOnly, isTablet } from 'react-device-detect';

const yesterday = moment().subtract(1, 'day');
const tomorrow = moment().add(1, 'day');
// const yesterday = moment();
const disablePastDt = current => {
  if (current.isAfter(yesterday)) {
    return current.isoWeekday() !== 6 && current.isoWeekday() !== 7;
  } else {
    return false;
  }
};

const getDateVal = selectedDateInCalendar => {
  return moment(selectedDateInCalendar, 'DD/MM/YYYY').calendar(null, {
    // when the date is closer, specify custom values
    // lastWeek: '[Last] dddd',
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'DD/MM/YYYY',
    // when the date is further away, use from-now functionality
    sameElse: 'DD/MM/YYYY',

    // sameElse: function () {
    //   return selectedDateInCalendar;
    // },
  });
};

export default class DateInput extends Component {
  selectedDateInCalendar;
  closeCalendar;
  sDate;
  state = {
    selectedData: 'Today',
    sDate: moment(),
    isCalendarOpen: false,
  };

  componentDidMount = () => {
    let selectedData = getDateVal(this.props.initialValue);
    this.sDate = this.props.initialValue;
    this.setState({
      selectedData: selectedData,
      sDate: this.props.initialValue,
    });
  };

  onToggleCalendar = () => {
    const { isCalendarOpen } = this.state;
    this.setState({
      isCalendarOpen: !isCalendarOpen,
      sDate: this.sDate,
    });

    var bodyEle = document.querySelector('body');
    if (bodyEle.classList.contains('lock-scroll')) {
      if (isCalendarOpen) {
        bodyEle.classList.remove('calendar-open');
      } else {
        bodyEle.classList.add('calendar-open');
      }
    }
    if (isTablet || isMobileOnly) {
      if (isCalendarOpen) {
        scrollBlocker.disable();
        bodyEle.classList.remove('calendar-open');
      } else {
        scrollBlocker.enable();
        bodyEle.classList.add('calendar-open');
      }
    }
  };

  RenderDay = (props, currentDate, selectedDate) => {
    // console.log('** renderDay >> ', props);
    const { dateEnableFrom } = this.props;
    if (currentDate.isAfter(dateEnableFrom)) {
      if (currentDate.isoWeekday() === 6 || currentDate.isoWeekday() === 7) {
        props.className += ' weekend-date';
      }
    } else {
      props.className += ' past-date';
    }

    // Adds 0 to the days in the days view
    return (
      <td {...props}>
        <span {...props}>{currentDate.date()}</span>
      </td>
    );
  };

  render() {
    const { selectedData, isCalendarOpen, sDate } = this.state;

    const {
      // values,
      touched,
      errors,
      handleChange,
      SelectDateButtonText,
      // handleBlur,
      setFieldValue,
      fields,
      onInputFocus,
    } = this.props;

    return (
      <div css={Styles.dateform}>
        {isCalendarOpen && <div css={Styles.overlay}></div>}
        <DatePicker
          initialValue={this.props.initialValue}
          dateFormat="DD/MM/YYYY"
          renderInput={(dProps, openCalendar, closeCalendar) => {
            this.selectedDateInCalendar = dProps.value;
            this.closeCalendar = closeCalendar;
            return (
              <div css={Styles.dateHolder}>
                <Input
                  className="dateinputfield"
                  autocomplete="off"
                  id="date"
                  onFocus={() => {
                    openCalendar();
                    if (onInputFocus) {
                      onInputFocus();
                    }
                  }}
                  value={selectedData}
                  defaultValue={selectedData}
                  placeholder={SelectDateButtonText}
                  error={errors.date && touched.date}
                  errorMessage={errors.date}
                />
                <span
                  className="icon-holder"
                  css={Styles.iconChevronHolder}
                  onClick={openCalendar}
                  aria-hidden="true"
                >
                  <Icon name="chevron-down" />
                </span>
              </div>
            );
          }}
          renderView={(viewMode, renderCalendar) => {
            return (
              <div className="wrapper">
                {renderCalendar()}
                <div className="controls">
                  <button
                    type="button"
                    onClick={param => {
                      let selectedDateInCalendar = this.selectedDateInCalendar;

                      if (selectedDateInCalendar) {
                        setFieldValue('date', selectedDateInCalendar);
                        this.sDate = selectedDateInCalendar;

                        selectedDateInCalendar = moment(
                          selectedDateInCalendar,
                          'DD/MM/YYYY',
                        ).calendar(null, {
                          // when the date is closer, specify custom values
                          // lastWeek: '[Last] dddd',
                          lastDay: '[Yesterday]',
                          sameDay: '[Today]',
                          nextDay: '[Tomorrow]',
                          nextWeek: 'DD/MM/YYYY',
                          // when the date is further away, use from-now functionality
                          sameElse: 'DD/MM/YYYY',

                          // sameElse: function () {
                          //   return selectedDateInCalendar;
                          // },
                        });

                        this.setState({
                          selectedData: selectedDateInCalendar,
                        });
                      }
                      this.closeCalendar();
                    }}
                  >
                    Select Date
                  </button>
                </div>
              </div>
            );
          }}
          renderDay={this.RenderDay}
          onChange={value => {
            // console.log('** date change in cal', value);
            this.setState({ sDate: value });
          }}
          initialViewMode="days"
          timeFormat={false}
          closeOnSelect={false}
          closeOnClickOutside={true}
          isValidDate={this.props.disablePastDt}
          autocomplete="off"
          onOpen={this.onToggleCalendar}
          onClose={this.onToggleCalendar}
          value={sDate}
        />
      </div>
    );
  }
}
